export const NUMBER_REGEX = /^\d+$/;

export const FLOAT_OR_INT_REGEX = /^\d+(\.\d+)?$/;

export const URL_REGEX =
  /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&=]*)/;
